module.exports = __webpack_public_path__ + "static/img/banner_2.d80e5f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner_2.jpg
// module id = g4pO
// module chunks = 1